module.exports = __webpack_public_path__ + "img/blog_menu_pic8.1f9be35b.png";